import React from "react";
import Track from "./track";
import "./participant.scss";
import { connect } from "react-redux";
class Participant extends React.Component {
  constructor(props) {
    super(props);
    const existingPublications = Array.from(
      this.props.participant.tracks.values()
    );
    const existingTracks = existingPublications.map(
      (publication) => publication.track
    );
    const nonNullTracks = existingTracks.filter((track) => track !== null);

    this.state = {
      tracks: nonNullTracks,
    };
  }
  componentDidMount() {
    if (!this.props.local) {
      this.props.participant.on("trackSubscribed", (track) =>
        this.addTrack(track)
      );
      //findClass += ' notLocalParticipant';
    }
  }

  addTrack(track) {
    this.setState({
      tracks: [...this.state.tracks, track],
    });
  }
  render() {
    return (
      <div
        className={`${this.props.localParticipant} ${
          this.props.localParticipant == "participant"
            ? this.props.rmtParticipantDevice
            : ""
        }`}
        id={this.props.participant.identity}
      >
        {this.state.tracks.map((track) => (
          <Track
            key={track}
            filter={this.state.filter}
            track={track}
            localParticipant={this.props.localParticipant}
          />
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    rmtParticipantDevice: state.videoConsultationReducer.rmtParticipantDevice,
  };
};
export default connect(mapStateToProps)(Participant);
